import { Component, ChangeDetectionStrategy, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import type { AssistantMessage, Message } from "@ag-ui/core";
import { RenderToolCalls } from "../core/render-tool-calls";

@Component({
  standalone: true,
  selector: "agent-chat-tool-calls-view",
  imports: [CommonModule, RenderToolCalls],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <agent-render-tool-calls [message]="message()" [messages]="messages()" [isLoading]="isLoading()">
    </agent-render-tool-calls>
  `,
})
export class AgentChatToolCallsView {
  readonly message = input.required<AssistantMessage>();

  readonly messages = input.required<Message[]>();

  readonly isLoading = input<boolean>(false);
}
